let posterSlidersArray = []

function posterSliders() {
    $(".catalog-poster").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        posterSlidersArray[index] = new Swiper(`.catalog-poster[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            disableOnInteraction: false,
            effect: 'fade',
            autoplay: {
                delay: 3000,
            },
            navigation: {
                nextEl: `.catalog-poster[data-slider-id="${index}"] .swiper-button-next`,
                prevEl: `.catalog-poster[data-slider-id="${index}"] .swiper-button-prev`,
            },
            on: {
                init: function () {
                    // playVideo($(`.catalog-poster[data-slider-id="${index}"]`))
                },
                slideChangeTransitionEnd: function () {
                    playVideo(`catalog-poster[data-slider-id="${index}"]`)
                },
            },
        })
        $(`.catalog-poster[data-slider-id="${index}"] .swiper-container`).mouseover(function() {
            posterSlidersArray[index].autoplay.stop();
        });
        $(`.catalog-poster[data-slider-id="${index}"] .swiper-container`).mouseleave(function() {
            posterSlidersArray[index].autoplay.start();
        });
    })

    function playVideo(el) {
        let isVideoSlideActive = $(`.${el}`).find(".swiper-slide-active").hasClass("_video")

        if(isVideoSlideActive){
            let video = $(`.${el} .video video`)[0]
            video.load();
        }
    }
}

function collectionBannerSlider() {
    var swiper = new Swiper('.collection-banner .swiper-container', {
        slidesPerView: 2,
        spaceBetween: 0,
        loopAdditionalSlides: 100,
        loop: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: '.collection-banner .swiper-button-next',
            prevEl: '.collection-banner .swiper-button-prev',
        },
    })
}

function modeSlider() {
    var swiper = new Swiper('.mode .swiper-container', {
        slidesPerView: 6,
        spaceBetween: 0,
        navigation: {
            nextEl: '.mode .swiper-button-next',
            prevEl: '.mode .swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                    fill: 'row',
                },
            },
            993: {
                slidesPerView: 6,
                grid: {
                    rows: 1,
                },
            },
        }
    })
}

function bannerSlider() {
    var swiper = new Swiper('.banner .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        navigation: {
            nextEl: '.banner .swiper-button-next',
            prevEl: '.banner .swiper-button-prev',
        },
    })
}

let sameSlidersArray = []

function sameSliders() {
    $(".same-card").each(function(index, el) {
        $(el).attr("data-slider-id", `${index}`)
        sameSlidersArray[index] = new Swiper(`.same-card[data-slider-id="${index}"] .swiper-container`, {
            slidesPerView: "auto",
            spaceBetween: 0,
            effect: 'fade',
            mousewheelControl: true,
            fadeEffect: {
                crossFade: true
            },
            // allowTouchMove: false,
            direction: 'vertical',
            pagination: {
                el: `.same-card[data-slider-id="${index}"] .swiper-pagination`,
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
                320: {
                    direction: 'horizontal',
                },
                576: {
                    direction: 'vertical',
                },
            }
        })

        $(`.same-card[data-slider-id="${index}"] .swiper-pagination-bullet`).hover(function() {
            $( this ).trigger( "click" );
        });
    })

}

function compareSlider() {
    var swiper = new Swiper('.compare .swiper-container', {
        slidesPerView: "auto",
        spaceBetween: 0,
    })
}

function aboutLinksSlider() {
    var swiper = new Swiper('.about-links .swiper-container', {
        slidesPerView: "auto",
        spaceBetween: 0,
        navigation: {
            nextEl: '.about-links .swiper-button-next',
            prevEl: '.about-links .swiper-button-prev',
        },
    })
}

function historySlider() {
    var swiper = new Swiper('.history .swiper-container', {
        slidesPerView: "auto",
        spaceBetween: 0,
        scrollbar: {
            el: '.history .swiper-scrollbar',
            draggable: true,
            dragSize: 34
        },
        navigation: {
            nextEl: '.history .swiper-button-next',
            prevEl: '.history .swiper-button-prev',
        },
        pagination: {
            el: '.history .swiper-pagination',
            type: 'fraction',
        },
    })
}

sameSliders()
modeSlider()
bannerSlider()
posterSliders()
compareSlider()
collectionBannerSlider()
aboutLinksSlider()
historySlider()
